import script from "./LingoTooltipIconComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoTooltipIconComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LingoTooltipIconComponent.vue?vue&type=style&index=0&id=384ecced&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384ecced"]])

export default __exports__